// One list for every lead and client — mirrors VEC_MS/backend/marketing/sources.py.
export const LEAD_SOURCES = [
  { value: 'TIKTOK', label: 'TikTok' },
  { value: 'INSTAGRAM', label: 'Instagram' },
  { value: 'FACEBOOK', label: 'Facebook' },
  { value: 'WHATSAPP', label: 'WhatsApp' },
  { value: 'WEBSITE', label: 'Website / Google' },
  { value: 'APP', label: 'VisionExploit app' },
  { value: 'REFERRAL', label: 'Referral (client / alumni)' },
  { value: 'AGENT', label: 'Agent / partner' },
  { value: 'SCHOOL_VISIT', label: 'School visit' },
  { value: 'WALK_IN', label: 'Walk-in / office' },
  { value: 'EVENT', label: 'Event / expo' },
  { value: 'OTHER', label: 'Other' },
];

export const sourceLabel = (value) => LEAD_SOURCES.find((s) => s.value === value)?.label || '';

// Brand-neutral chip colours per platform (the three socials get their own).
export const SOURCE_COLORS = {
  TIKTOK: '#111827', INSTAGRAM: '#c026d3', FACEBOOK: '#2563eb', WHATSAPP: '#16a34a',
};

export const DISMISS_REASONS = [
  { value: 'SPAM', label: 'Spam / test' },
  { value: 'DUPLICATE', label: 'Duplicate' },
  { value: 'NOT_A_FIT', label: 'Not a fit for our services' },
  { value: 'UNREACHABLE', label: 'Could not reach them' },
  { value: 'NOT_INTERESTED', label: 'Not interested any more' },
  { value: 'OTHER', label: 'Other' },
];

export const LEAD_STEPS = [
  { value: 'CALLED', label: 'Called' },
  { value: 'WHATSAPP', label: 'WhatsApp message sent' },
  { value: 'INFO_SENT', label: 'Information pack sent' },
  { value: 'CONSULT_BOOKED', label: 'Consultation booked' },
  { value: 'CONSULT_HELD', label: 'Consultation held' },
];

// Paid / organic / unknown as one select value.
export const paidValue = (v) => (v === true ? 'PAID' : v === false ? 'ORGANIC' : '');
export const paidFromValue = (v) => (v === 'PAID' ? true : v === 'ORGANIC' ? false : null);
